import { NotebookView } from 'v2/views/layouts/notebook/types';
import { create } from 'zustand';

type NotebookViewStore = {
  notebookView: NotebookView;
  setNotebookView: (updatedNotebookView: NotebookView) => void;
};

const useNotebookViewStore = create<NotebookViewStore>((set) => ({
  notebookView: NotebookView.Widget,
  setNotebookView: (updatedNotebookView: NotebookView) =>
    set({ notebookView: updatedNotebookView }),
}));

export default useNotebookViewStore;
